<template>
  <b-row class="mt-1">
    <!-- submit and reset -->
    <b-col v-if="disableForm" cols="12">
      <b-button variant="primary" class="mr-1" @click="edit">
        {{ labelEdit }}
      </b-button>
    </b-col>
    <b-col v-else cols="12">
      <b-button
        v-if="permissionEdit || permissionInsert"
        id="btnSave"
        variant="primary"
        class="mr-1"
        :disabled="loadingButton"
        @click="save"
        data-cy="save-btn"
      >
        {{ loadingButton ? "Aguarde..." : labelSave }}
        <b-spinner v-if="loadingButton" small></b-spinner>
      </b-button>
      <b-button
        v-if="showCancel"
        id="btnCancel"
        variant="outline-secondary"
        @click="cancel"
        data-cy="cancel-btn"
      >
        Cancelar
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BButton, BSpinner } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  props: {
    disableForm: {
      type: Boolean,
      default: true,
    },
    permissionEdit: {
      type: Boolean,
      default: true,
    },
    permissionInsert: {
      type: Boolean,
      default: true,
    },
    loadingButton: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    labelEdit: {
      type: String,
      default: "Editar",
    },
    labelSave: {
      type: String,
      default: "Salvar",
    },
  },
  methods: {
    save() {
      this.$emit("save");
    },
    edit() {
      this.$emit("edit");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
